import * as React from 'react';
import { cloneDeep, uniqueId } from 'lodash';
import { AddButton, BodyGroup, HelperPopover } from '@component/index';
import { instance, isReadMode } from '@lib/index';
import { StateUpdateTableComp } from './state-update-table';
import '@style/component/data-query.less';
import { localizedString } from '@locale/index';
import { SourceType } from '@config/index';
import {
  Attribute,
  StateUpdateUpdateFuncArgumentConfig,
  StateUpdateInfo,
  FrameItem,
  IntentInfo,
  CompositeInfo,
  EntityInfo,
  StateUpdateTriggerMethod
} from '@interface/index';

export interface StateUpdateInfoCompProps {
  history: any;
  title: string;
  frame: FrameItem;
  availableIntents: IntentInfo[];
  availableComposites: CompositeInfo[];
  availableEntities: EntityInfo[];
  disabled?: boolean;
  data: StateUpdateInfo[];
  fallback?: boolean;
  selectedParameters: Attribute[];
  onChange: (args: StateUpdateUpdateFuncArgumentConfig) => void;
}
export interface StateUpdateInfoCompState {
  tag: string;
}

export class StateUpdateInfoComp extends React.PureComponent<
  StateUpdateInfoCompProps,
  StateUpdateInfoCompState
> {
  public state: StateUpdateInfoCompState = {
    tag: uniqueId()
  };

  private bodyGroup?: BodyGroup;

  render() {
    const { disabled = false,
      title,
      frame,
      data
    } = this.props;

    return (
      <BodyGroup
        foldable
        defaultFolded
        title={title.length ? title : localizedString('state_update')}
        titleExtra={<HelperPopover localizedKey={this.props.fallback ? 'frame_hint_fallback' : 'frame_hint_transitions'} />}
        extra={(data && data.length && !this.props.fallback && <AddButton
          disabled={disabled || !!frame.originKey}
          onClick={() => {
            this.handleNewTableRow();
          }}
        /> || '')
        }
        onRef={(ref: any) => {
          this.bodyGroup = ref;
        }}
      >
        <div className="suggestion__wrap">
          <div className="sug-wrap">{this.tableComp()}</div>
        </div>
      </BodyGroup>
    );
  }

  tableComp = () => {
    const props = this.props;
    const state = this.state;
    const {
      availableIntents,
      availableComposites,
      availableEntities,
      history
    } = props;

    return (
      <StateUpdateTableComp
        fallback={props.fallback}
        history={history}
        title={props.title}
        frame={props.frame}
        availableIntents={availableIntents}
        availableComposites={availableComposites}
        availableEntities={availableEntities}
        tag={state.tag}
        disabled={props.disabled}
        selectedParameters={props.selectedParameters}
        data={props.data || []}
        onChange={props.onChange}
        onAdd={this.handleNewTableRow}
      />
    );
  };

  handleNewTableRow = () => {
    const props = this.props;

    // if (this.bodyGroup) {
    //   this.bodyGroup.open();
    // }

    const next = cloneDeep(props.data || []);

    let name = '';

    if (props.fallback) {
      name = 'fallback';
    } else {
      for (let i = 1; i <= next.length + 1; i++) {
        const tryName = `transition${i}`;
        if (next.findIndex(item => item.name === tryName) === -1) {
          name = tryName;
          break;
        }
      }
    }

    next.unshift({
      name,
      ownerId: props.frame.id,
      ownerType: props.frame.type,
      triggerMethod: props.fallback ? StateUpdateTriggerMethod.Fallback : StateUpdateTriggerMethod.Event,
      eventStates: [],
      conditionType: SourceType.CODE_EXPRESSION,
      conditions: [],
      conditionCode: '',
      stateConfig: {
        state: ''
      },
      channels: [],
      dirty: true
    });

    props.onChange({
      nextStateUpdates: next
    });

    // setTimeout(() => {
    //   instance.emit(`@addStateUpdateInfo${this.state.tag}`, { isNew: true });
    // }, 0.1);
  };
}
